import React, {useEffect, useState, useMemo} from "react";
import MenuManagementAccor from "components/atoms/MenuManagement";
import productimg from "assets/productimg.png";
import {MenuManageMentHeader} from "components/atoms/MenuManagement/MenuManagement.styles";
import MenuOverview from "components/atoms/MenuManagement/Overview";
import Button from "components/molecules/Button";
import {RiFileCopy2Fill} from "react-icons/ri";
import ChoiceGroup from "components/atoms/MenuManagement/ChoiceGroup";
import CopyStore from "components/atoms/MenuManagement/CopyStore/Index";
import ModalContainer from "components/molecules/ModalContainer";
import menuStoreService from "services/menu-storeService";
import {useAuthContext} from "Context/authContext";
import ComboCreator from "components/atoms/MenuManagement/ComboCreator";
import {useSelector, useDispatch} from "react-redux";
import {setSelectedStoreId} from "store/reducers/businessSlice";
import Select from "components/molecules/Select";
import {IoIosArrowDown} from "react-icons/io";
import foodie from "assets/Home/foodie.svg";

const dummyData = [
    {
        categoryName: "Chef’s Specialties",
        items: [
            {
                id: 1,
                img: productimg,
                name: "Chicken B.B.Q",
                Description: "lorem ipsum is a simply dummy...",
                variation: "Reg ($ 150), Med ($ 180)",
                choiceGroup: "Choices of Sauce",
                status: "Available",
                offer: "Active",
                price: "$4",
                oldPrice: "$5",
            },
        ],
    },
];

const MenuManagement = () => {
    const [selected, setSelected] = useState(null);
    const [activeTab, setActiveTab] = useState("Overview");
    const [selectedMenu, setSelectedMenu] = useState();
    const {fetch} = useAuthContext();
    const [menu, setMenu] = useState();
    const {defaultStore, businessId, selectedStoreId: selectedStoreIdFromRedux} = useSelector(state => state.business);
    const dispatch = useDispatch();

    // Store management state
    const [selectedStore, setSelectedStore] = useState("");
    const [allStores, setAllStores] = useState([]);
    const [currentStoreId, setCurrentStoreId] = useState(selectedStoreIdFromRedux || defaultStore);

    const getMenu = async id => {
        const res = await menuStoreService.getMenuById(id);
        setMenu(res?.menu);
    };

    // Fetch all stores for dropdown
    const getAllStores = async () => {
        try {
            console.log("🏪 Menu Management: Fetching stores for businessId:", businessId);
            const res = await menuStoreService.getAllstores(businessId);
            console.log("🏪 Menu Management: Stores API response:", res);

            const storesData = res?.items || res?.data?.items || res?.stores || [];
            console.log("🏪 Menu Management: Processed stores data:", storesData);
            setAllStores(storesData);

            if (storesData.length > 0) {
                const hasValidSelection = storesData.some(s => s._id === currentStoreId);
                const hasValidReduxSelection = storesData.some(s => s._id === selectedStoreIdFromRedux);

                let storeToSelect = null;

                if (hasValidReduxSelection) {
                    storeToSelect = selectedStoreIdFromRedux;
                } else if (hasValidSelection) {
                    storeToSelect = currentStoreId;
                } else {
                    const defaultStoreObj = storesData.find(s => s.default_branch);
                    storeToSelect = defaultStoreObj ? defaultStoreObj._id : storesData[0]._id;
                }

                console.log("🏪 Menu Management: Setting store as current:", storeToSelect);
                setCurrentStoreId(storeToSelect);
                dispatch(setSelectedStoreId(storeToSelect));
            } else {
                console.log("🏪 Menu Management: No stores found");
            }
        } catch (error) {
            console.error("🏪 Menu Management: Error fetching stores:", error);
        }
    };

    useEffect(() => {
        if (selectedMenu) {
            getMenu(selectedMenu);
        }
    }, [selectedMenu, fetch]);

    // Fetch stores on component mount
    useEffect(() => {
        if (businessId) {
            getAllStores();
        }
    }, [businessId]);

    // Update currentStoreId when selectedStoreIdFromRedux or defaultStore changes
    useEffect(() => {
        if (selectedStoreIdFromRedux) {
            setCurrentStoreId(selectedStoreIdFromRedux);
        } else if (defaultStore && !currentStoreId) {
            setCurrentStoreId(defaultStore);
        }
    }, [selectedStoreIdFromRedux, defaultStore, currentStoreId]);

    // Update selectedStore when allStores or currentStoreId changes
    useEffect(() => {
        console.log("Updating selectedStore - currentStoreId:", currentStoreId, "allStores:", allStores);
        const matchingStore = allStores?.find(store => store._id === currentStoreId);
        if (matchingStore) {
            const storeOption = {
                label: matchingStore.title || matchingStore.name,
                value: matchingStore._id,
            };
            setSelectedStore(storeOption);
        }
    }, [allStores, currentStoreId]);

    function handelSelected(ind) {
        if (selected === ind) {
            setSelected(null);
        } else {
            setSelected(ind);
        }
    }

    function handelApi(elem, name) {
        console.log(elem, name);
    }

    // Create stores options for dropdown
    const stores = useMemo(() => {
        console.log("🏪 Menu Management: Creating store options from allStores:", allStores);

        if (!allStores || allStores.length === 0) {
            console.log("🏪 Menu Management: No stores available for dropdown");
            return [];
        }

        const storeOptions = allStores.map(store => ({
            value: store._id,
            label: store.title || store.name,
        }));
        console.log("🏪 Menu Management: Store dropdown options:", storeOptions);
        return storeOptions;
    }, [allStores]);

    return (
        <>
            <MenuManageMentHeader>
                <div className="heading">
                    <h2>Menu Management</h2>
                    <p>Make changes to your menu items, prices and photos easily!</p>
                    {/* Store Selector Dropdown */}
                </div>

                <div className="tabs">
                    <div className="tab">
                        <strong
                            className={activeTab === "Overview" ? "active" : ""}
                            onClick={() => setActiveTab("Overview")}>
                            Overview
                        </strong>
                        <strong
                            className={activeTab === "Choice Group" ? "active" : ""}
                            onClick={() => setActiveTab("Choice Group")}>
                            Choice Group
                        </strong>
                        <strong
                            className={activeTab === "Combo Creator" ? "active" : ""}
                            onClick={() => setActiveTab("Combo Creator")}>
                            Combo Creator
                        </strong>
                    </div>
                    <div className="copy">
                        <ModalContainer
                            width={750}
                            title="Copy Menu to Branch"
                            btnComponent={({onClick}) => (
                                <Button sm onClick={onClick}>
                                    <RiFileCopy2Fill />
                                    Copy to Stores
                                </Button>
                            )}
                            content={({onClose}) => <CopyStore onClose={onClose} />}
                        />
                    </div>
                </div>
            </MenuManageMentHeader>
            {activeTab === "Overview" && (
                <>
                    <MenuOverview
                        selectedMenu={selectedMenu}
                        setSelectedMenu={setSelectedMenu}
                        currentStoreId={currentStoreId}
                        selected={selected}
                        setSelected={setSelected}
                        handelSelected={handelSelected}
                        handelApi={handelApi}
                    />
                </>
            )}
            {activeTab === "Choice Group" && <ChoiceGroup data={dummyData} currentStoreId={currentStoreId} />}
            {activeTab === "Combo Creator" && <ComboCreator currentStoreId={currentStoreId} />}
        </>
    );
};

export default MenuManagement;
